import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bca_logo_nthe",
  "use": "bca_logo_nthe-usage",
  "viewBox": "0 0 300.82 81.97",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 300.82 81.97\" id=\"bca_logo_nthe\">\n    <path fill=\"currentColor\" d=\"M64.69.12h11.13v81.86H65.74L11.02 18.93v63.04H0V.12h9.49l55.2 63.58V.12zM86.37 0h68.38v10.43h-28.54v71.54h-11.78V10.43H86.37V0zM223.54.12h11.72v81.86h-11.72V46.35h-46v35.62h-11.72V.12h11.72v35.39h46V.12zM253.3.12h46.41v10.43h-34.69v24.96h33.52V46h-33.52v25.43h35.8v10.43H253.3V.12z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol